<template>
  <v-container fluid fill-height pt-15 class="background test_purple">
    <v-row class="test_red fill-height" justify="center" align="center">
      <v-col cols="10" md="6" lg="4" class="test_yellow">
        <card-default>
          <template v-slot:header>
            <v-container>
              <span
                class="title-modal-card"
                v-text="$t('customerProfile.change_password')"
              />
            </v-container>
          </template>
          <template v-slot:body>
            <v-form
              ref="form"
              v-model="valid"
              :disabled="$store.getters.isLoading"
            >
              <v-row no-gutters justify="center">
                <v-col cols="12" class="text-center mb-2">
                  <h2 v-text="$t('general.reset_code')" />
                </v-col>

                <CodeInput
                  ref="activationInput"
                  :fields="4"
                  :auto-focus="false"
                  :loading="$store.getters.isLoading"
                  class="input"
                  :class="form.token.length < 4 ? 'component-code-error' : ''"
                  @change="onChange"
                />
                <v-col cols="12" class="text-center">
                  <span
                    v-if="form.token.length < 4"
                    class="code-error"
                    v-text="$t('inputs.invalid')"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-show="false"
                    v-model="form.token"
                    type="number"
                    :rules="[$rules.activationCode]"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.email"
                    :label="$t('inputs.email')"
                    clearable
                    type="email"
                    inputmode="email"
                    :rules="[$rules.required, $rules.email]"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="form.password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    class="inputs-default"
                    :label="$t('inputs.new_password')"
                    :type="show ? 'text' : 'password'"
                    :rules="[$rules.required, $rules.minPassword]"
                    @click:append="show = !show"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.repeatPassword"
                    class="inputs-default"
                    :label="$t('inputs.repeat_new_password')"
                    :type="show ? 'text' : 'password'"
                    :rules="[
                      $rules.required,
                      $rules.repeatPasswordRules(
                        form.repeatPassword,
                        form.password
                      ),
                    ]"
                  />
                </v-col>
              </v-row>
            </v-form>
          </template>
          <template v-slot:actions>
            <v-col>
              <ButtonSuccess :valid="valid" @click="resetPassword()" />
            </v-col>
          </template>
        </card-default>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CodeInput from "vue-verification-code-input";
export default {
  name: "ResetPassword",
  components: {
    CodeInput,
  },
  data: () => ({
    show: false,
    valid: false,
    form: new Form({
      token: "",
      email: "",
      password: "",
      repeatPassword: "",
    }),
  }),
  mounted() {
    this.$store.dispatch("loading/done");
    setTimeout(() => {
      this.focusActiveCode();
    }, 500);
  },
  methods: {
    resetPassword: async function () {
      const self = this;
      self.$store.dispatch("loading/start");

      const { data } = await self.form.post("/app/reset/password");
      Toast.fire({
        icon: "success",
        title: data.message,
      });
      setTimeout(() => {
        self.$router.push({ name: "Home" });
        self.$store.dispatch("loading/done");
      }, 500);
    },
    onChange(v) {
      const self = this;
      self.form.token = v;
    },
    focusActiveCode: async function () {
      document.querySelectorAll('[data-id="' + 0 + '"]')[0].focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.background {
  background-color: #aaa !important;
}
.code-error {
  color: red;
  font-size: 0.7rem;
}
</style>
<style lang="scss">
.component-code-error .react-code-input input {
  border-color: red !important;
}
</style>
